<template>
    <div class="@container">
        <h2 class="scaffold-body mb-2">See how Nadia's coaching changes when she understands your schedule.</h2>
        <div class="grid grid-cols-1 @sm:grid-cols-2 rounded-lgr shadow-lg bg-white">
            <!-- Left: Without calendar -->
            <div class="border flex flex-col">
                <div class="px-6 py-4">
                    <h3 class="inline-block bg-valence-grey-50 rounded-lgr px-3 py-1 body-small">Without calendar</h3>
                </div>
                <div class="flex flex-col gap-3 px-8 py-6 border-t border-valence-grey-200 h-full">
                    <div class="flex items-center gap-2 h-5">
                        <i class="bi bi-calendar text-valence-grey-500 text-lg leading-none" aria-hidden="true"></i>
                    </div>
                    <p class="nadia-chat-semibold text-valence-grey-850">No awareness into your work week</p>
                    <p class="body text-valence-grey-750">Coaching based only on what you choose to share — no visibility into your actual meetings, workload, or schedule.</p>
                </div>
            </div>

            <!-- Right: With calendar -->
            <div class="border flex flex-col bg-valence-primary-50/30">
                <div class="px-6 py-4">
                    <h3 class="inline-block bg-valence-primary-200 rounded-lgr px-3 py-1 body-small">With your calendar</h3>
                </div>
                <div class="flex flex-col gap-3 px-8 py-6 border-t border-valence-grey-200 h-full">
                    <div class="flex items-center h-5">
                        <span class="body-small text-valence-grey-600 uppercase tracking-wide leading-none">Sample</span>
                    </div>
                    <p class="nadia-chat-semibold text-valence-grey-850">Burnout risk spotted early</p>
                    <p class="nadia-chat">
                        You've had
                        <strong>4 consecutive days with more than 5 hours of meetings</strong>
                        and limited focus time scheduled this week.
                    </p>
                    <p class="nadia-chat">
                        Between your 1:1 with
                        <span class="inline-flex items-center gap-1 align-bottom bg-valence-grey-50 rounded px-1.5 py-0.5 body-small-bold">
                            <PerspectiveDot dimension="EI" size="sm" />
                            Maya </span
                        >, project reviews, and recurring team meetings, your calendar suggests a pace that may be difficult to sustain. Consider protecting dedicated focus blocks
                        before next week fills up.
                    </p>
                    <p class="scaffold-body-small text-valence-primary-500 mt-auto flex items-center gap-1">
                        <i class="bi bi-stars" aria-hidden="true"></i>
                        This is the kind of insight you'll receive once your calendar is connected.
                    </p>
                </div>
            </div>
        </div>
        <div class="flex justify-center items-center mt-6">
            <BaseButton theme="primary" :class="{ 'rounded-3xl body px-6': !tonalThemeEnabled }" @click="handleConnect">Connect your calendar &rarr;</BaseButton>
        </div>
    </div>
</template>

<script setup lang="ts">
import BaseButton from "~vue/components/BaseButton.vue";
import PerspectiveDot from "~vue/Perspective/PerspectiveDot.vue";
import { useCalendarStore } from "~vue/stores/calendarStore";
import AmplitudeEventNames from "~vue/utils/amplitudeEventNames";
import { logUserInteraction } from "~vue/utils/logUtils";
import { tonalThemeEnabled } from "~vue/utils/theme";
import { onMounted } from "vue";

const calendarStore = useCalendarStore;
// TODO: Remove the legacy calendar branch once the tonal theme becomes the default.

onMounted(() => logUserInteraction(AmplitudeEventNames.CALENDAR_INTEGRATION_CARD_SHOWN));

const handleConnect = () => {
    calendarStore.setShowConnectCalendarDialog(true);
    logUserInteraction(AmplitudeEventNames.CALENDAR_INTEGRATION_STARTED);
};
</script>
